import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { obtenerAdministradores } from "../../../store/admin/thunkAdmins";
import ModalCrearAdmins from "./ModalCrearAdmins";
import ModalEditarAdmin from "./ModalEditarAdmin";

export const ListaAdmins = () => {
    const dispatch = useDispatch();


    const { rol_admin } = useSelector((state) => state.auth);



    

    const [admins, setAdmins] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Estados para el modal de creación y edición
    const [openCreateModal, setOpenCreateModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [selectedAdmin, setSelectedAdmin] = useState(null);

    // Función para obtener los administradores
    const fetchAdmins = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            const response = await dispatch(obtenerAdministradores());
            setAdmins(response || []);
        } catch (err) {
            console.error("Error al obtener los administradores:", err);
            setError("No se pudo cargar la lista de administradores.");
        } finally {
            setLoading(false);
        }
    }, [dispatch]);

    // Efecto para cargar los administradores al montar el componente
    useEffect(() => {
        fetchAdmins();
    }, [fetchAdmins]);

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(100);
    const [searchTerm, setSearchTerm] = useState("");

    const totalPages = Math.ceil(admins.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value.toLowerCase());
        setCurrentPage(1);
    };

    const filteredAdmins = admins.filter((admin) => admin.name_admin.toLowerCase().includes(searchTerm) || admin.email_admin.toLowerCase().includes(searchTerm) || admin.cedula_admin.includes(searchTerm));

    const currentAdmins = filteredAdmins.slice(startIndex, startIndex + itemsPerPage);

    // Funciones para controlar los modales
    const handleOpenCreateModal = () => setOpenCreateModal(true);
    const handleCloseCreateModal = () => setOpenCreateModal(false);

    const handleOpenEditModal = (admin) => {
        setSelectedAdmin(admin);
        setOpenEditModal(true);
    };

    const handleCloseEditModal = () => {
        setSelectedAdmin(null);
        setOpenEditModal(false);
    };

    if (rol_admin != 1) {
        return <h2>No tienes permisos para ver esta página</h2>;
    }

    return (
        <div className="table-responsive">
            <h2>Lista de Administradores</h2>

            <div className="mb-3">
                <label htmlFor="searchAdmin">Buscar por nombre, correo o cédula:</label>
                <input id="searchAdmin" type="text" value={searchTerm} onChange={handleSearchChange} placeholder="Ingresa nombre, correo o cédula" className="form-control w-auto d-inline-block ms-2" />
            </div>

            <div className="mb-3">
                <button className="btn btn-success" onClick={handleOpenCreateModal}>
                    Crear Usuario
                </button>
                <br />
                <label htmlFor="itemsPerPage">Elementos por página:</label>
                <select id="itemsPerPage" value={itemsPerPage} onChange={handleItemsPerPageChange} className="form-select w-auto d-inline-block ms-2">
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                </select>
            </div>

            {loading ? (
                <div className="text-center">Cargando...</div>
            ) : error ? (
                <div className="text-center text-danger">{error}</div>
            ) : (
                <table className="table table-striped table dt-responsive w-100 display text-left hoverable-table" style={{ fontSize: "15px", width: "100%", textAlign: "left" }}>
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Email</th>
                            <th>Teléfono</th>
                            <th>Cédula</th>
                            <th>Puesto</th>
                            <th>Área</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentAdmins.length > 0 ? (
                            currentAdmins.map((admin) => (
                                <tr key={admin.id_admin} onClick={() => handleOpenEditModal(admin)} style={{ cursor: "pointer" }}>
                                    <td>{admin.name_admin}</td>
                                    <td>{admin.email_admin}</td>
                                    <td>{admin.phone_admin}</td>
                                    <td>{admin.cedula_admin}</td>
                                    <td>{admin.puesto}</td>
                                    <td>{admin.area}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={6} className="text-center">
                                    No se encontraron administradores
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            )}

            <div className="d-flex justify-content-center align-items-center mt-3">
                <button className="btn btn-primary mx-2" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                    Anterior
                </button>
                <span>
                    Página {currentPage} de {totalPages}
                </span>
                <button className="btn btn-primary mx-2" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                    Siguiente
                </button>
            </div>

            {/* Modal para crear usuario */}
            <ModalCrearAdmins open={openCreateModal} handleClose={handleCloseCreateModal} functions={fetchAdmins} type="user" />

            {/* Modal para editar usuario */}
            {selectedAdmin && <ModalEditarAdmin open={openEditModal} handleClose={handleCloseEditModal} functions={fetchAdmins} datos={selectedAdmin} type="user" />}
        </div>
    );
};
